import { styled } from "@mui/material";

export const MainDiv = styled("div")(() => ({
  border: "1px solid #E4E7EC",
  borderRadius: "8px",
  overflow: "hidden",
}));

export const ItemsDiv = styled("div")(() => ({
  paddingBottom: "12px",
}));
